/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFill: {
  name: 'fill';
  data: string;
} = {
  name: 'fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.586 4a2 2 0 0 1 2.828 0L14 7.586a2 2 0 0 1 0 2.828L10.414 14a2 2 0 0 1-2.828 0L4 10.414a2 2 0 0 1 0-2.828L7.586 4ZM9 5.414 6.414 8h5.172L9 5.414Zm0 7.172L6.414 10h5.172L9 12.586ZM5 19a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Zm13-5a1 1 0 1 1-2 0c0-.373.215-.934.661-1.47.13-.156.26-.283.373-.38.104.09.222.208.342.357.409.506.624 1.076.624 1.493Zm-.674-2.054s-.006.004-.02.008a.087.087 0 0 1 .02-.008Zm-.548.024a.067.067 0 0 1-.011-.005l.01.005ZM20 14a3 3 0 0 1-6 0c0-2 2-4 3-4 1.152 0 3 2 3 4Z" fill="currentColor"/></svg>`,
};
